import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=1443a58e&scoped=true&"
var script = {}
import style0 from "./Introduction.vue?vue&type=style&index=0&id=1443a58e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1443a58e",
  null
  
)

export default component.exports